import React, { useState, useRef, useEffect } from "react";
import { DoorOpenIcon, DoorClosedIcon } from "../../Styles/Icons";
import EventLogTooltip from "../EventLogTooltip";
import styles from "./styles.module.scss";
import theme from "../../Styles/theme.scss";

const getDoorIcon = (event) => {
  if (event?.[0].status === "opened") {
    return (
      <DoorOpenIcon width="10" height="14" style={{ color: theme.white }} />
    );
  }
  return (
    <DoorClosedIcon width="10" height="14" style={{ color: theme.white }} />
  );
};

const EventLogSquare = ({
  value,
  index,
  events,
  entranceDoor = false,
  time,
  closeTooltip,
  setCloseTooltip,
  outsideState = "",
  outsideData = undefined,
  outsideHighlightKey = "",
  activeOutsideHighlightKey = null,
  setActiveOutsideHighlightKey = () => {},
}) => {
  // Add a ref to the square to extract it's position on the screen so as to position the tooltip
  const squareRef = useRef(null);
  const coordinatesSquare = squareRef.current?.getBoundingClientRect();

  const [tooltipEvents, setTooltipEvents] = useState(null);
  // Figure out if it's an even square for different default colouring
  const isEven = index % 2 === 0;
  const isOutsideOnly = !value && !!outsideState;
  const hasTooltipContent = (events?.length || 0) > 0 || outsideData;
  const isOutsideLineHighlighted =
    !!outsideHighlightKey && outsideHighlightKey === activeOutsideHighlightKey;

  const outsideLineClass = `${styles.outside_line} ${
    outsideState === "goes_outside"
      ? styles.outside_line_start
      : outsideState === "returns_home"
        ? styles.outside_line_end
        : styles.outside_line_middle
  } ${isOutsideLineHighlighted ? styles.outside_line_highlighted : ""}`;

  // If the user scrolls close the tooltip
  useEffect(() => {
    if (closeTooltip) {
      setTooltipEvents(null);
      // Return the closeTooltip state to false so others can be opened
      setCloseTooltip?.(false);
    }
  }, [closeTooltip, setCloseTooltip]);

  // Where there's no events or outside insight return one of the two coloured squares
  if (!value && !outsideState) {
    return <div className={isEven ? styles.square_even : styles.square_odd} />;
  }
  // Where there are events or outside insight return the square with optional outside line

  return (
    <div
      className={`${
        value ? styles.square : isEven ? styles.square_even : styles.square_odd
      } ${tooltipEvents && !isOutsideOnly ? styles.square_selected : ""}`}
      onMouseEnter={(e) => {
        // To prevent the onMouseEnter handler firing when the users hovers over the tooltip (a child element) check it's id
        const target = e.target;
        if (target.id === "parent" && hasTooltipContent) {
          setTooltipEvents(events || []);
        }
        outsideHighlightKey &&
          setActiveOutsideHighlightKey(outsideHighlightKey);
      }}
      onMouseLeave={() => {
        setTooltipEvents(null);
        setActiveOutsideHighlightKey(null);
      }}
      onClick={() => hasTooltipContent && setTooltipEvents(events || [])}
      id={"parent"}
      ref={squareRef}
    >
      {outsideState && <span className={outsideLineClass} />}
      <div className={styles.square_value}>
        {value === 1 && entranceDoor
          ? getDoorIcon(events)
          : value !== 0
            ? value
            : ""}
      </div>
      {tooltipEvents && hasTooltipContent && (
        <EventLogTooltip
          entranceDoor={entranceDoor}
          tooltipEvents={tooltipEvents}
          outsideState={outsideState}
          outsideData={outsideData}
          coordinatesSquare={coordinatesSquare}
          time={time}
        />
      )}
    </div>
  );
};

export default EventLogSquare;
